import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Platform, View, StyleSheet , Text,SafeAreaView, ScrollView, FlatList, Button, Image,StatusBar, TouchableOpacity } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { useTailwind } from 'tailwind-rn';

//import HTMLView from 'react-native-htmlview';

//myComponents
import Header from './Header.js';
import Footer from './Footer.js';
import ResourceList from './ResourceList.js';
import ResourceMenu from './ResourceMenu.js';


//const maxh = Dimensions.get("window").height
const Main = () => {
    const tailwind = useTailwind();
    const navigation = useNavigation();
    

    useLayoutEffect(() => {
        navigation.setOptions({
            headerShown: false,
        });
        console.log("image");
        //console.log(matconlogo);
    }, []);


    let goUploadJson = (object) => {
      console.log("presionado");
      navigation.navigate("Json uploader");
    }

    //const [assets, error] = useAssets([require('../assets/matcon-logo1.png'), require('../assets/matcon-logo1.png')]);



    return (
        <SafeAreaView style={ styles.container }>
            <Header/>
            <ScrollView style={ tailwind("bg-white") }>
                <Text style={ tailwind("text-red-500") }>Plataforma MAT_CON</Text>
                {Platform.OS != 'web' ? <ResourceMenu/> : <ResourceList/> }
                <Button
                    title= {"Subir json"} 
                    onPress= { goUploadJson }
                    onClick= { goUploadJson }
                />
                <View style ={ tailwind("hidden") }>
                    <View style ={ tailwind("bg-matconyellow") }><Text>Yellow</Text></View>
                    <View style ={ tailwind("bg-matconpurple") }><Text>Purple</Text></View>
                    <View style ={ tailwind("bg-matconred") }><Text>Red</Text></View>
                    <View style ={ tailwind("bg-matconblue") }><Text>Blue</Text></View>
                    <View style ={ tailwind("bg-matcondarkblue") }><Text>Dark blue</Text></View>
                    <View style ={ tailwind("bg-matcongreen") }><Text>Green</Text></View>
                </View>
                <View style ={ tailwind("h-52") }></View>
                <Footer/>
            </ScrollView>   
        </SafeAreaView>
    );
};


const styles = StyleSheet.create({
    container: {
        flex: 1,
        marginTop:StatusBar.currentHeight
    },
    button: {
        backgroundColor: "rgba(52, 52, 52, 0.8)"
    },
    mainContainer:
    {
        minHeight: 4000,
    },
    a: {
        fontWeight: '300',
        color: '#FF3366', // make links coloured pink
      },
})

  

export default Main;